import {
    ALL_WAREHOUSE_SUP,
  } from './config/roles'

export const cfgRoleButton = {
    btnInventoryCheck_Create: ALL_WAREHOUSE_SUP,
    btnInventoryCheck_Edit: ALL_WAREHOUSE_SUP,
    btnInventoryCheck_Delete: ALL_WAREHOUSE_SUP,
    btnInventoryCheck_Reassign: ALL_WAREHOUSE_SUP,
    btnInventoryCheck_EditTag: ALL_WAREHOUSE_SUP,
    btnInventoryCheck_Priorization: ALL_WAREHOUSE_SUP,
}